export const getListPaginationBounds = (totalItems, rowsPerPage) => {
  const safeTotal = Number(totalItems) || 0;
  const safeRowsPerPage = Math.max(1, Number(rowsPerPage) || 12);
  const totalPages = safeTotal === 0 ? 0 : Math.ceil(safeTotal / safeRowsPerPage);
  const maxPageNumber = Math.max(0, totalPages - 1);

  return { totalPages, maxPageNumber };
};

export const clampPageNumber = (pageNumber, totalItems, rowsPerPage) => {
  const { maxPageNumber } = getListPaginationBounds(totalItems, rowsPerPage);
  const safePage = Math.max(0, Number(pageNumber) || 0);
  return Math.min(safePage, maxPageNumber);
};
